import i18n from '@/libs/i18n'

export default {
  quoteStatusName(status) {
    switch (status) {
      case 'pending':
        return i18n.t('pending')
      case 'awaiting_customer_response':
        return i18n.t('awaiting_customer_response')
      case 'buyout':
        return i18n.t('buyout')
      case 'bidding':
        return i18n.t('bidding')
      case 'awaiting_bid_approval':
        return i18n.t('awaiting_bid_approval')
      case 'bid_approved':
        return i18n.t('bid_approved')
      case 'bid_rejected':
        return i18n.t('rejected')
      case 'bid_credited':
        return i18n.t('bid_credited')
      default:
        return ''
    }
  },
  quoteStatusColor(status) {
    switch (status) {
      case 'pending':
        return 'secondary'
      case 'awaiting_customer_response':
        return 'info'
      case 'buyout':
        return 'success'
      case 'bidding':
        return 'warning'
      case 'awaiting_bid_approval':
        return 'info'
      case 'bid_approved':
        return 'info'
      case 'bid_rejected':
        return 'danger'
      case 'bid_credited':
        return 'info'
      default:
        return ''
    }
  },
  paymentStatusName(status) {
    switch (status) {
      case 'payment_pending':
        return i18n.t('payment_pending')
      case 'awaiting_payment_approval':
        return i18n.t('awaiting_payment_approval')
      case 'payment_approved':
        return i18n.t('payment_approved')
      case 'payment_rejected':
        return i18n.t('payment_rejected')
      case 'credit_approved':
        return i18n.t('credit_approved')
      default:
        return ''
    }
  },
  paymentStatusColor(status) {
    switch (status) {
      case 'awaiting_payment_approval':
        return 'secondary'
      case 'payment_approved':
        return 'success'
      case 'payment_rejected':
        return 'danger'
      case 'credit_approved':
        return 'warning'
      case 'payment_pending':
        return 'danger'
      default:
        return ''
    }
  },

  // Single source of truth for the customer invoice status shown across the app
  // (badge in the invoices view and the "F. cliente" column in the quote lists).
  invoiceStatus(quote) {
    const hasInvoice = Boolean(quote && quote.facturapi_invoice_id)
    const cancellationInProcess = ['pending', 'verifying', 'in_process']
      .includes(quote && quote.facturapi_invoice_cancellation_status)

    if (hasInvoice && quote.facturapi_invoice_status === 'canceled') {
      return { label: i18n.t('invoiceCanceled'), variant: 'danger' }
    }
    if (hasInvoice && cancellationInProcess) {
      return { label: i18n.t('invoiceCancellationInProcess'), variant: 'warning' }
    }
    if (quote && quote.is_invoiced) {
      return { label: i18n.t('invoiced'), variant: 'success' }
    }
    return { label: i18n.t('pending'), variant: 'secondary' }
  },

  shippingStatusName(status) {
    switch (status) {
      case 'shipping_pending':
        return i18n.t('shippingPending')
      case 'awaiting_shipping_approval':
        return i18n.t('awaitingShippingApproval')
      case 'shipping_approved':
        return i18n.t('shippingApproved')
      case 'shipping_rejected':
        return i18n.t('shippingRejected')
      default:
        return ''
    }
  },

  shippingStatusColor(status) {
    switch (status) {
      case 'shipping_pending':
        return 'secondary'
      case 'awaiting_shipping_approval':
        return 'info'
      case 'shipping_approved':
        return 'success'
      case 'shipping_rejected':
        return 'danger'
      default:
        return ''
    }
  },

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  },

  transpose(mx) {
    const h = mx[0].length
    const w = mx.length
    // const matrix = [...mx]
    // const matrixT = Array(w).fill([])
    const t = []
    for (let i = 0; i < h; i += 1) {
      // Insert a new row (array)
      t[i] = []

      // Loop through every item per item in outer array (width)
      for (let j = 0; j < w; j += 1) {
        // Save transposed data.
        t[i][j] = mx[j][i]
      }
    }
    return t
  },

  validZone() {
    return true
  },
}
